import { useContext } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';

const useGetIncompatibleBottle = (id, targetSource) => {
  const [{ incompatible }] = useContext(dataStore);
  const [{ customData }] = useContext(appStore);
  let isIncompatible = false;

  if (!(incompatible && incompatible.source === targetSource)) {
    return isIncompatible;
  }

  // ボトルに対応する非互換リストを取得
  const exclusionList = incompatible.list[id];
  if (exclusionList) {
    // 非互換リストのアイテムが選択されていれば、非互換フラグを返す
    exclusionList.forEach((exclusionId) => {
      customData.partsList.forEach((item) => {
        if (item.id === exclusionId) {
          isIncompatible = true;
        }
      });
    });
  }
  return isIncompatible;
};

export default useGetIncompatibleBottle;
